import React from "react";
import "./GlitchTheme.css";

interface Track {
  id: number;
  title: string;
  duration: string;
}

const tracklist: Track[] = [
  { id: 1, title: "pressing record", duration: "2:33" },
  { id: 2, title: "telescope", duration: "2:45" },
  { id: 3, title: "the math doesn't add up", duration: "3:15" },
  { id: 4, title: "reiki & hiccups", duration: "3:12" },
  { id: 5, title: "player two", duration: "2:44" },
  { id: 6, title: "discrete variables", duration: "2:53" },
  { id: 7, title: "cause and effect", duration: "3:17" },
  { id: 8, title: "mercury in retrograde", duration: "2:36" },
  { id: 9, title: "that's finally okay", duration: "2:14" },
];

const RLCP: React.FC = () => {
  return (
    <div className="app-container">
      {/* ── HEADER ──────────────────────────────────────── */}
      <header className="glitch-wrapper">
        <h1
          className="glitch-title fade-in-delay"
          data-text="real-life complicated problems"
        >
          real-life complicated problems
        </h1>

        <p className="rlcp-subtitle blur-text-reveal">
          álbum disponível em todas as plataformas
        </p>

        <div className="store-section" style={{ marginTop: "1.5rem" }}>
          <a href="https://linktr.ee/eduardobertozzi" className="store-btn">
            <span>OUVIR AGORA</span>
          </a>
        </div>
      </header>

      {/* ── TRACKLIST ───────────────────────────────────── */}
      <section className="tracklist-container">
        <ul className="track-list">
          {tracklist.map((track) => (
            <li key={track.id} className="track-item">
              <div className="track-item-left">
                <span className="track-num">
                  {track.id.toString().padStart(2, "0")}
                </span>
                <span className="track-title">{track.title}</span>
              </div>

              <div className="track-item-right">
                <a href="#" className="track-listen-link">
                  [ OUVIR ]
                </a>
                <span className="track-duration">{track.duration}</span>
              </div>
            </li>
          ))}
        </ul>
      </section>

      {/* ── FOOTER ──────────────────────────────────────── */}
      <footer className="rlcp-footer">
        &copy; 2026 EDUARDO BERTOZZI. TODOS OS DIREITOS RESERVADOS.
      </footer>
    </div>
  );
};

export default RLCP;
